module.exports = __webpack_public_path__ + "img/flags.5c58d0e1.png";